import {UserList} from "./UserList";
import {UserEdit} from "./UserEdit";
import {UserCreate} from "./UserCreate";

export default {
    list: UserList,
    create: UserCreate,
    edit: UserEdit
};
